import React, { Component } from 'react';
import Axios from 'axios';
import styled from 'styled-components';
import InfiniteScroll from 'react-infinite-scroller';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Checkbox from 'material-ui/Checkbox';
import Dialog from 'material-ui/Dialog';
import { Select } from '../shared/styled-components';
import isEmpty from 'lodash/isEmpty';
import isNull from 'lodash/isNull';
import isEqual from 'lodash/isEqual';
import isFunction from 'lodash/isFunction';
import debounce from 'lodash/debounce';
import getPath from 'lodash/get';
import find from 'lodash/find';
import chunk from 'lodash/chunk';
import xor from  'lodash/xor';
import { LoadingWrapper } from '../../../../styles/styled';
import Loading from '../../../../components/Loading';
import { ActionButton } from '../../../../components/buttons/buttons';
import EpisodeStatsModal from '../episode_stats_modal';
import {
  getSoundcastsManagedv2,
  getSoundcastManagedEpisodes,
  isUserPlanAlive,
  isSoundcastsManagedLoadedAndCompleted,
  isSoundcastManagedEpisodesBusy,
  identifyManagedOperation,
} from '../../../../helpers/userinfoHelper';
import { PAGINATED_EPISODE_LIMIT } from '../../../../helpers/episodes';
import { getSoundcastItunesImageUrl } from '../../../../helpers/soundcasts';
import { FlexiRow } from '../../../../styles/styled';
import EpisodeDraggable from './EpisodeDraggable';
import {
  RelativeContainer,
  FloatingFlexiWrapper,
  EpisodesHeadRow,
  ScrollableContent,
  EmptyEpisodeList,
  ActionButtonWrappers,
  EpisodeRowTitle,
  EpisodeColumn,
  CheckboxWrapper,
} from './styled';

import ostyles from '../shared/styles';
import { soundcastManager, episodeManager } from '../../../../helpers/managers';
const styles = {
  ...ostyles,
};
// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const getLoadingOperations = operation => {
  return getPath(
    {
      'fetch-episodes': 'Loading Tracks...',
      'bulk-delete': 'Deleting selected tracks',
      'bulk-publish': 'Publishing selected tracks',
      'bulk-draft': 'Unpublishing selected tracks',
      'bulk-public': 'Updating selected tracks status to Public',
      'bulk-private': 'Updating selected tracks status to Private',
      'bulk-replicate': 'Replicating selected tracks',
    },
    operation,
    'Loading...'
  );
};

class SoundcastEpisodes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showStatsModal: false,
      currentEpisode: null,
      episodes: [],
      episodesTotal: 0,
      hasLoaded: false,
      soundcast: {},
      operation: '',
      loading: false,
      loadingMsg: 'Loading...',
      modal: {
        show: false,
        title: '',
        content: '',
        actionLabel: 'Change Plan',
        onClose: () => {},
        upgrade: false,
      },
      bulkReplicateModal: {
        show: false,
        title: '',
        content: '',
        actionLabel: 'Replicate',
        onClose: () => {},
        upgrade: false,
      },
      selectAllEpisodes: false,
      selectedEpisodes: [],
      selectedSoundcastId: '',
      updatingFeed: false,
      scrollContentRef: null,
      replicateToSoundcastId: '',
    };

    this.handleStatsModal = this.handleStatsModal.bind(this);
    this.loadEpisodes = this.loadEpisodes.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.handleAddNewEpisode = this.handleAddNewEpisode.bind(this);
    this.editEpisode = this.editEpisode.bind(this);
    this.viewEpisode = this.viewEpisode.bind(this);
    this.onUpdateEpisode = this.onUpdateEpisode.bind(this);
    this.showAlertModal = this.showAlertModal.bind(this);
    this.showBulkReplicateModal = this.showBulkReplicateModal.bind(this);
    this.onChangeReplicateToSoundcastId = this.onChangeReplicateToSoundcastId.bind(this);
    this.closeBulkReplicateModal = this.closeBulkReplicateModal.bind(this);
    this.updateFeedDebounceHandler = debounce(this.handleFeedUpdate, 2000);
    this.loadMorePaginatedEpisodes = this.loadMorePaginatedEpisodes.bind(this);
    this.scrollContentHandler = this.scrollContentHandler.bind(this);
    this.updateReduxTreeForReplicatedEpisodes = this.updateReduxTreeForReplicatedEpisodes.bind(this);
  }

  componentDidMount() {
    this.loadEpisodes();
  }

  componentDidUpdate(_, prevState) {
    if (!prevState.hasLoaded) {
      this.loadEpisodes();
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { id: soundcastId, managed } = nextProps;

    // soundcats managed should be ready
    if (!isSoundcastsManagedLoadedAndCompleted(managed)) {
      return null;
    }

    console.log('getDerivedStateFromProps', nextProps);

    // return a loading state when the an api is being called at
    const operation = identifyManagedOperation(managed);
    const isRequestBusy = isSoundcastManagedEpisodesBusy(soundcastId, managed);
    console.log('isSoundcastManagedEpisodesBusy', isRequestBusy, operation);
    if (isRequestBusy) {
      return {
        operation,
        loading: true,
        loadingMsg: getLoadingOperations(operation),
      };
    }

    const soundcastManaged = getSoundcastsManagedv2();
    const soundcast = soundcastManaged.find(item => isEqual(item.id, soundcastId));
    const otherSoundcasts = soundcastManaged.filter(
      item => !isEqual(item.id, soundcastId) && !item.bundle
    );
    const episodes = getSoundcastManagedEpisodes(soundcastId);
    const episodesTotal = getPath(managed, `episodes.byTotal.${soundcastId}`, 0);
    const pageStart = Math.ceil(episodes.length / PAGINATED_EPISODE_LIMIT);

    // handle previous state here
    const {
      operation: prevOperation,
      selectAllEpisodes: prevSelecteAllEpisodes,
      selectedEpisodes: prevSelectedEpisodes,
    } = prevState;

    console.log(`Total of episodes ${episodes.length}/${episodesTotal}`, 'page', pageStart);

    // for bulk operations, reset selected Episodes
    const selectedEpisodes = prevOperation.includes('bulk') ? [] : prevSelectedEpisodes;
    const selectAllEpisodes = isEmpty(selectedEpisodes) ? false : prevSelecteAllEpisodes;

    return {
      operation,
      soundcast,
      otherSoundcasts,
      episodes,
      episodesTotal,
      selectAllEpisodes,
      selectedEpisodes,
      pageStart,
      loading: false,
      hasLoaded: true,
    };
  }

  handleAddNewEpisode() {
    const { id: soundcastID, history } = this.props;
    history.push({
      pathname: '/dashboard/add_episode',
      state: { soundcastID },
    });
  }

  loadEpisodes() {
    const { soundcast, episodes } = this.state;
    if (!isEmpty(soundcast)) {
      const offset = (episodes || []).length;
      console.log(`loadEpisodes offset ${offset}`);
      this.props.fetchManagedSoundcastEpisodesCreator({ soundcast, offset });
    }
  }

  loadMorePaginatedEpisodes(page = 1) {
    try {
      const { soundcast, episodes } = this.state;
      const offset = (episodes || []).length;
      console.log(`loadMorePaginatedEpisodes offset ${offset} page ${page}`);
      this.props.fetchManagedSoundcastEpisodesCreator({ soundcast, offset });
    } catch (err) {
      console.log('Error retrieving episodes', err.message);
    }
  }

  hasMorePaginatedEpisodes() {
    const { episodes, episodesTotal, loading } = this.state;

    // this will avoid the next call to `loadMorePaginatedEpisodes` function
    // when the component updates loading state changes
    // failed to do so will keep the infinite scroll component
    // to call the said function and increase the page count
    if (loading) {
      return false;
    }

    return episodesTotal > episodes.length;
  }

  scrollContentHandler(ref) {
    const { scrollContentRef = null } = this.state;
    if (isNull(ref) || !isNull(scrollContentRef)) {
      return;
    }

    this.setState({ scrollContentRef: ref });
  }

  renderPaginatedEpisodesLoader() {
    return (
      <EpisodesLoader key={0}>
        <Loading align="center" size={40} fontSize={1.6} text="Loading tracks" />
      </EpisodesLoader>
    );
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const srcIndex = getPath(result, 'source.index', 0);
    const dstIndex = getPath(result, 'destination.index', 0);

    // dropped on same location
    if (isEqual(srcIndex, dstIndex)) {
      return;
    }

    const { soundcast, episodes } = this.state;
    this.props.updateSoundcastEpisodesOrderCreator({
      soundcast,
      episodes: reorder(episodes, srcIndex, dstIndex),
    });
  }

  handleFeedUpdate() {
    return new Promise((resolve, reject) => {
      const { userInfo } = this.props;
      const { updatingFeed, soundcast } = this.state;
      const {
        id: soundcastId,
        itunesCategory,
        itunesExplicit,
        podcastFeedVersion,
      } = soundcast || {};

      // only there's a feed and we're not updating the feed
      if (!(podcastFeedVersion && !updatingFeed)) {
        return resolve();
      }

      this.setState({ updatingFeed: true }, async () => {
        try {
          await Axios.post('/api/create_feed', {
            soundcastId,
            itunesExplicit,
            itunesImage: getSoundcastItunesImageUrl(soundcast),
            itunesCategory,
            email: userInfo.publisher.email,
            firstName: userInfo.firstName,
          });

          resolve();
        } catch (err) {
          reject(err);
        } finally {
          this.setState({ updatingFeed: false });
        }
      });
    });
  }

  handleStatsModal() {
    this.setState({ showStatsModal: !this.state.showStatsModal });
  }

  attachSelectedNewProps(episode) {
    return {
      ...episode,

      // new props
      episodeId: episode.id,
      soundcastId: episode.soundcastID,
    };
  }

  handleEpisodeSelectAll = (_e, isChecked) => {
    const { episodes } = this.state;
    const selectedEpisodes = isChecked
      ? [...episodes]
          .filter(episode => !isEmpty(episode.title))
          .map(episode => {
            return this.attachSelectedNewProps({
              id: episode.id,
              soundcastID: episode.soundcastID,
            });
          })
      : [];

    this.setState({
      selectAllEpisodes: isChecked,
      selectedEpisodes,
    });
  };

  handleEpisodeSelect = episode => {
    return (_e, isChecked) => {
      let { selectAllEpisodes, selectedEpisodes } = this.state;
      if (isChecked) {
        selectedEpisodes.push(
          this.attachSelectedNewProps({
            id: episode.id,
            soundcastID: episode.soundcastID,
          })
        );
      } else {
        // look for the already selectedEpisodes index and remove it
        selectedEpisodes = selectedEpisodes.filter(item => {
          return !(isEqual(item.id, episode.id) && isEqual(item.soundcastID, episode.soundcastID));
        });
      }

      // if selectAll was selected
      // turn it off once a user
      // selected items manually
      this.setState({
        selectAllEpisodes: selectAllEpisodes ? false : selectAllEpisodes,
        selectedEpisodes,
      });
    };
  };

  isEpisodeSelected = episode => {
    const { selectedEpisodes } = this.state;
    const selected = selectedEpisodes.find(item => {
      return isEqual(item.id, episode.id) && isEqual(item.soundcastID, episode.soundcastID);
    });

    return !isEmpty(selected);
  };

  isAllEpisodesSelected = () => {
    const { episodes = [], selectedEpisodes = [] } = this.state;
    return !isEmpty(episodes) && isEqual(episodes.length, selectedEpisodes.length);
  };

  handleBulkActionSelect = bulkAction => {
    return () => {
      const { userInfo } = this.props;
      const { selectedEpisodes } = this.state;
      console.log('handleBulkActionSelect', bulkAction, selectedEpisodes);
      if (isEmpty(selectedEpisodes)) {
        return this.showAlertModal({
          content: 'You haven`t selected any tracks.',
          alertOnly: true,
        });
      }

      // verify plan
      if (!isUserPlanAlive(userInfo)) {
        return this.showAlertModal({
          content: `You need a valid subscription plan to access this feature`,
          subscribe: true,
        });
      }

      if (isFunction(this[`handleBulk${bulkAction}`])) {
        this[`handleBulk${bulkAction}`]();
      }
    };
  };

  handleBulkReplicate = () => {
    const { selectedEpisodes, episodes: oepisodes } = this.state;
    const toReplicateEpisodes = [...oepisodes].filter(({ episodeId, soundcastId }) => {
      return find(selectedEpisodes, { episodeId, soundcastId });
    });

    if (!isEmpty(toReplicateEpisodes)) {
      this.showBulkReplicateModal({
        actionBtnHandler: this.handlerReplicateBulkEpisodes(toReplicateEpisodes),
      });
    }
  };

  async updateReduxTreeForReplicatedEpisodes(soundcastId) {
    const { addUpdateManagedSoundcastEpisode } = this.props;
    const soundcast = await soundcastManager.getById(soundcastId);
    soundcast.soundcastId = soundcastId;

    const newEpisodeIds = Object.keys(soundcast.episodes || {});
    const oldEpisodes = getSoundcastManagedEpisodes(soundcastId);
    const oldEpisodeIds = oldEpisodes.map(ep => ep.episodeId);
    const episodeIds = xor(oldEpisodeIds, newEpisodeIds);

     // update the redux tree for replicated episodes
    const promises = episodeIds.map( episodeId => {
      new Promise(async (resolve, reject) => {
        try {
          const episode = await episodeManager.getById(episodeId);
          if (!isEmpty(episode)) {
            episode.episodeId = episodeId;
            addUpdateManagedSoundcastEpisode(soundcast, episode);
          }
          resolve();
        } catch (err) {
          reject(err);
        }
      });
    });

    const groups = chunk(promises, 50);
    for (const group of groups) {
      await Promise.all(group);
      await new Promise(resolve => setTimeout(resolve, 500));
    }
  };

  handlerReplicateBulkEpisodes(episodes) {
    return async () => {
      try {
        const { soundcast, replicateToSoundcastId } = this.state;

        this.closeBulkReplicateModal();
        await this.props.bulkActionEpisodesCreator({
          soundcast,
          replicateToSoundcastId,
          episodes,
          action: 'replicate',
        });
        await this.updateReduxTreeForReplicatedEpisodes(replicateToSoundcastId);
        this.showAlertModal({
          content: 'The selected tracks are replicated',
          alertOnly: true,
        });
      } catch (error) {
        console.error(error);
        this.closeBulkReplicateModal();
        this.showAlertModal({
          content: 'There was an error replicating the tracks.',
          alertOnly: true,
        });
      }
    };
  }

  handleBulkDelete = () => {
    const { selectedEpisodes, episodes: oepisodes } = this.state;
    const toDeleteEpisodes = [...oepisodes].filter(({ episodeId, soundcastId }) => {
      return find(selectedEpisodes, { episodeId, soundcastId });
    });

    console.log('toDeleteEpisodes', toDeleteEpisodes);
    if (!isEmpty(toDeleteEpisodes)) {
      const hasProcessingEpisodes = find(toDeleteEpisodes, { episodeState: 'processing' });
      const warningMessage = !isEmpty(hasProcessingEpisodes)
        ? `Some of the tracks you selected are in processing. If you delete the track, processing tasks will stop.`
        : `Are you sure you want to delete selected tracks? This action cannot be undone.`;

      this.showAlertModal({
        content: warningMessage,
        deleting: true,
        actionBtnHandler: this.handlerDeleteBulkEpisodes(toDeleteEpisodes),
      });
    }
  };

  handlerDeleteBulkEpisodes(episodes) {
    return async () => {
      try {
        const { soundcast } = this.state;

        this.closeAlertModal();
        await this.props.deleteManagedSoundcastEpisodesCreator({ soundcast, episodes });
        if (this.state.episodes.length <= 0) {
          await this.props.fetchManagedSoundcastEpisodesCreator({ soundcast });
        }
        this.showAlertModal({
          content: 'All selected tracks are deleted',
          alertOnly: true,
        });
      } catch (error) {
        console.error(error);
        this.showAlertModal({
          content: 'There was an error removing the tracks.',
          alertOnly: true,
        });
      }
    };
  }

  onChangeSoundcastId = evt => {
    console.log('selected soundcast id', evt.target.value);
    this.setState({ selectedSoundcastId: evt.target.value });
  };

  handleBulkPublish = () => {
    const { selectedEpisodes } = this.state;
    this.handlerCommonActionBulkEpisodes({
      action: 'publish',
      filter: ({ episodeId, soundcastId, episodeState, isPublished = false }) => {
        const validSelected = find(selectedEpisodes, { episodeId, soundcastId });
        return validSelected && (episodeState === 'ready' || !episodeState) && !isPublished;
      },
      messages: {
        EMPTY: 'Selected tracks are either in processing state or already published.',
        PROCESSING:
          'Some of the tracks you selected are in processing. Publishing is currently not possible.',
        LOADER_START: 'Publishing selected tracks',
        LOADER_SUCCESS: 'All selected tracks have been published.',
        ERROR: 'There was a problem when publishing the tracks.',
      },
    });
  };

  handleBulkUnPublish = () => {
    const { selectedEpisodes } = this.state;
    this.handlerCommonActionBulkEpisodes({
      action: 'draft',
      filter: ({ episodeId, soundcastId, isPublished = false }) => {
        return find(selectedEpisodes, { episodeId, soundcastId }) && isPublished;
      },
      messages: {
        EMPTY: 'Selected tracks are either in processing state or already set to draft.',
        PROCESSING:
          'Some of the tracks you selected are in processing. Unpublishing is currently not possible.',
        LOADER_START: 'Unpublishing selected tracks',
        LOADER_SUCCESS: 'All selected tracks have been set to draft.',
        ERROR: 'There was a problem when unpublishing the tracks.',
      },
    });
  };

  handleBulkMakePublic = async () => {
    const { selectedEpisodes } = this.state;
    this.handlerCommonActionBulkEpisodes({
      action: 'public',
      filter: ({ episodeId, soundcastId, publicEpisode }) => {
        return find(selectedEpisodes, { episodeId, soundcastId }) && !publicEpisode;
      },
      messages: {
        EMPTY: 'Selected tracks are either in processing state or already public.',
        PROCESSING:
          'Some of the tracks you selected are in processing. Updating status is currently not possible.',
        LOADER_START: 'Updating selected tracks status to Public',
        LOADER_SUCCESS: 'All selected tracks have been set to Public.',
        ERROR: 'There was a problem when updating the tracks status.',
      },
    });
  };

  handleBulkMakePrivate = async () => {
    const { selectedEpisodes } = this.state;
    this.handlerCommonActionBulkEpisodes({
      action: 'private',
      filter: ({ episodeId, soundcastId, publicEpisode }) => {
        return find(selectedEpisodes, { episodeId, soundcastId }) && publicEpisode;
      },
      messages: {
        EMPTY: 'Selected tracks are either in processing state or already private.',
        PROCESSING:
          'Some of the tracks you selected are in processing. Updating status is currently not possible.',
        LOADER_START: 'Updating selected tracks status to Private',
        LOADER_SUCCESS: 'All selected tracks have been set to Private.',
        ERROR: 'There was a problem when updating the tracks status.',
      },
    });
  };

  handlerCommonActionBulkEpisodes = async (options = {}) => {
    const { episodes: oepisodes, soundcast } = this.state;
    const { action, filter, messages } = options;
    const episodes = [...oepisodes].filter(filter);

    if (isEmpty(episodes)) {
      return this.showAlertModal({
        content: messages.EMPTY,
        alertOnly: true,
      });
    }

    const hasProcessingEpisodes = find(episodes, { episodeState: 'processing' });
    if (hasProcessingEpisodes) {
      return this.showAlertModal({
        content: messages.PROCESSING,
        alertOnly: true,
      });
    }

    // call api to publish/unpublish the episodes
    try {
      this.closeAlertModal();
      await this.props.bulkActionEpisodesCreator({ soundcast, episodes, action });
      this.showAlertModal({
        content: messages.LOADER_SUCCESS,
        alertOnly: true,
      });
    } catch (error) {
      console.error(error);
      this.showAlertModal({
        content: messages.ERROR,
        alertOnly: true,
      });
    }
  };

  viewEpisodeAnalytics(episode) {
    this.setState({ currentEpisode: episode });
    this.handleStatsModal();
  }

  onUpdateEpisode(episode, overwrite = false) {
    const { soundcast } = this.state;
    const { addUpdateManagedSoundcastEpisode } = this.props;
    addUpdateManagedSoundcastEpisode(soundcast, episode, overwrite);
  }

  editEpisode(episode) {
    const { userInfo, history } = this.props;
    history.push({
      pathname: `/dashboard/edit_episode/${episode.id}`,
      state: {
        id: episode.id,
        episode,
      },
    });
  }

  viewEpisode(e) {
    const { userInfo } = this.props;

    // verify plan
    if (!isUserPlanAlive(userInfo)) {
      this.showAlertModal({
        content: `You need a valid subscription plan to access this feature`,
        subscribe: true,
      });

      return e.preventDefault();
    }
  }

  deleteEpisode = episode => {
    const { soundcast } = this.state;
    const { userInfo } = this.props;
    const { title, episodeState } = episode;
    return async (_, force = false) => {
      // some times a force delete may occur, only when set
      // we have to make it silent also
      if (force) {
        await this.props.deleteManagedSoundcastEpisodesCreator({
          soundcast,
          episodes: [episode],
          cancellable: false,
          silent: true,
        });

        return this.setState({ soundcast });
      }

      const content =
        episodeState === 'processing'
          ? 'Selected track in processing, If you delete the track, processing tasks will stop.'
          : `Are you sure you want to delete ${title}? This action cannot be undone.`;

      this.showAlertModal({
        content,
        deleting: true,
        actionBtnHandler: this.handlerDeleteSingleEpisode(episode),
      });
    };
  };

  handlerDeleteSingleEpisode(episode) {
    return async () => {
      try {
        const { soundcast } = this.state;
        const { title } = episode;

        this.closeAlertModal();
        await this.props.deleteManagedSoundcastEpisodesCreator({ soundcast, episodes: [episode] });
        this.showAlertModal({
          content: `${title} has been deleted`,
          alertOnly: true,
        });
      } catch (error) {
        console.error(error);
        this.showAlertModal({
          content: 'There was an error removing the track.',
          alertOnly: true,
        });
      }
    };
  }

  alertModalHandler(metadata = {}) {
    let {
      show = false,
      title = '',
      content = '',
      subscribe = false,
      upgrade = false,
      deleting = false,
      onClose = false,
      alertOnly = false,
      actionBtnHandler = false,
    } = metadata;

    return () => {
      let { onClose: oldClose } = this.state.modal;
      this.setState(
        {
          modal: {
            ...this.state.modal,
            show,
            title,
            content,
            subscribe,
            upgrade,
            deleting,
            onClose: !show ? false : onClose,
            alertOnly,
            actionBtnHandler,
          },
        },
        () => {
          if (oldClose && !show) {
            oldClose();
          }
        }
      );
    };
  }

  bulkReplicateModalHandler(metadata = {}) {
    let {
      show = false,
      title = '',
      content = '',
      onClose = false,
      actionBtnHandler = false,
    } = metadata;

    return () => {
      let { onClose: oldClose } = this.state.bulkReplicateModal;
      this.setState(
        {
          bulkReplicateModal: {
            ...this.state.bulkReplicateModal,
            show,
            title,
            content,
            onClose: !show ? false : onClose,
            actionBtnHandler,
          },
        },
        () => {
          if (oldClose && !show) {
            oldClose();
          }
        }
      );
    };
  }

  showBulkReplicateModal(metadata = {}) {
    this.bulkReplicateModalHandler({
      show: true,
      ...metadata,
    })();
  }

  closeBulkReplicateModal() {
    this.bulkReplicateModalHandler({ show: false })();
    this.setState({ replicateToSoundcastId: '' });
  }

  showAlertModal(metadata = {}) {
    this.alertModalHandler({
      show: true,
      ...metadata,
    })();
  }

  closeAlertModal() {
    this.alertModalHandler({ show: false })();
  }

  renderAlertModal() {
    const {
      show,
      title,
      content,
      subscribe,
      upgrade,
      deleting,
      alertOnly,
      actionBtnHandler,
    } = this.state.modal;
    const actionBtnLabel = upgrade
      ? 'Upgrade'
      : subscribe
      ? 'Subscribe'
      : deleting
      ? 'Delete'
      : 'OK';
    const actionBtnClick =
      upgrade || subscribe
        ? () => this.props.history.push('/pricing')
        : actionBtnHandler
        ? actionBtnHandler
        : this.alertModalHandler({ show: false });
    const actions = [
      <div style={{ textAlign: 'center', padding: 20 }}>
        <ActionButton onClick={actionBtnClick}>{actionBtnLabel}</ActionButton>
        {alertOnly ? null : (
          <ActionButton
            textColor="#f76b1c"
            backgroundColor="#fff"
            onClick={this.alertModalHandler({ show: false })}>
            Cancel
          </ActionButton>
        )}
      </div>,
    ];

    return (
      <Dialog
        title={
          <div className="title-medium" style={{ fontWeight: 800, textAlign: 'center' }}>
            {title}
            <div
              style={{ cursor: 'pointer', float: 'right', fontSize: 29 }}
              onClick={this.alertModalHandler({ show: false })}>
              &#10799; {/* Close button (X) */}
            </div>
          </div>
        }
        actions={actions}
        modal={false}
        open={show}
        onRequestClose={this.alertModalHandler({ show: false })}>
        <div className="title-small" style={{ textAlign: 'center', padding: '0 20px' }}>
          {content}
        </div>
      </Dialog>
    );
  }

  renderBulkReplicateModal() {
    const { show, title, content, actionBtnHandler } = this.state.bulkReplicateModal;
    const actionBtnLabel = 'Replicate';
    const actionBtnClick = actionBtnHandler;
    const soundcasts = this.state.otherSoundcasts;

    const actions = [
      <div style={{ textAlign: 'center', padding: 20 }}>
        <ActionButton
          disabled={!this.state.replicateToSoundcastId}
          cursor={this.state.replicateToSoundcastId ? 'pointer' : 'not-allowed !important;'}
          onClick={actionBtnClick}>
          {actionBtnLabel}
        </ActionButton>

        <ActionButton
          textColor="#f76b1c"
          backgroundColor="#fff"
          onClick={this.closeBulkReplicateModal}>
          Cancel
        </ActionButton>
      </div>,
    ];

    return (
      <Dialog
        title={
          <div className="title-medium" style={{ fontWeight: 800, textAlign: 'center' }}>
            {title}
            <div
              style={{ cursor: 'pointer', float: 'right', fontSize: 29 }}
              onClick={this.closeBulkReplicateModal}>
              &#10799; {/* Close button (X) */}
            </div>
            <div style={styles.soundcastSelectWrapper}>
              <div style={styles.notesLabel}>Choose the soundcast to replicate the track(s) to</div>
              <Select
                value={this.state.replicateToSoundcastId}
                style={styles.soundcastSelect}
                onChange={this.onChangeReplicateToSoundcastId}>
                {isEmpty(soundcasts) ? (
                  <option>Loading...</option>
                ) : (
                  <option value="" disabled></option>
                )}
                {soundcasts &&
                  soundcasts.map((soundcast, i) => {
                    return (
                      <option value={soundcast.id} key={i}>
                        {soundcast.title}
                      </option>
                    );
                  })}
              </Select>
            </div>
          </div>
        }
        actions={actions}
        modal={false}
        open={show}
        onRequestClose={this.closeBulkReplicateModal}>
        <div
          className="title-small"
          style={{ textAlign: 'center', minHeight: '30px', padding: '0 20px' }}>
          {content}
        </div>
      </Dialog>
    );
  }

  onChangeReplicateToSoundcastId(e) {
    this.setState({
      replicateToSoundcastId: e.target.value,
    });
  }

  renderItems(provided) {
    const { episodes, pageStart, soundcast, scrollContentRef } = this.state;
    return (
      <div ref={provided.innerRef} {...provided.droppableProps}>
        <InfiniteScroll
          pageStart={pageStart}
          initialLoad={false}
          loadMore={this.loadMorePaginatedEpisodes}
          hasMore={this.hasMorePaginatedEpisodes()}
          loader={this.renderPaginatedEpisodesLoader()}
          useWindow={false}
          threshold={150}
          getScrollParent={() => scrollContentRef}>
          {episodes.map((episode, index) => {
            if (!('episodeId' in episode)) {
              return null;
            }

            return (
              <EpisodeDraggable
                key={`episode-${episode.episodeId}`}
                index={index}
                episode={episode}
                checked={this.isEpisodeSelected(episode)}
                onCheck={this.handleEpisodeSelect(episode)}
                onDelete={this.deleteEpisode(episode)}
                onEdit={() => this.editEpisode(episode)}
                hasLanding={soundcast.landingPage}
                onViewLanding={this.viewEpisode}
                onViewAnalytics={() => this.viewEpisodeAnalytics(episode)}
                onOpenChannel={this.props.openEpisodeChannel}
                onCloseChannel={this.props.closeEpisodeChannel}
                onUpdateEpisode={this.onUpdateEpisode}
              />
            );
          })}
        </InfiniteScroll>
        {provided.placeholder}
      </div>
    );
  }

  renderEpisodeList() {
    const { scrollContentRef, episodes } = this.state;
    if (isNull(scrollContentRef) || isEmpty(episodes)) {
      return null;
    }

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">{provided => this.renderItems(provided)}</Droppable>
      </DragDropContext>
    );
  }

  render() {
    const {
      episodes,
      soundcast,
      selectAllEpisodes,
      selectedEpisodes,
      loading,
      loadingMsg,
    } = this.state;

    console.log('SoundcastEpisodes render');

    return (
      <MuiThemeProvider>
        <RelativeContainer>
          <FloatingFlexiWrapper>
            <div>
              <FlexiRow className="row margin-one-half" alignItems="center">
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs12 title-medium">
                  {soundcast.title} - Tracks
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs12">
                  <ActionButtonWrappers>
                    <div className="btn-group margin-five-right sm-no-margin">
                      <button
                        disabled={selectedEpisodes.length === 0}
                        type="button"
                        className="dropdown-toggle text-medium font-weight-600"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false">
                        Bulk actions <span className="caret" />
                      </button>
                      <ul className="dropdown-menu">
                        <li>
                          <a onClick={this.handleBulkActionSelect('Delete')}>Delete</a>
                        </li>
                        <li role="separator" className="divider" />
                        <li>
                          <a onClick={this.handleBulkActionSelect('Publish')}>Publish</a>
                        </li>
                        <li>
                          <a onClick={this.handleBulkActionSelect('UnPublish')}>Unpublish</a>
                        </li>
                        <li role="separator" className="divider" />
                        <li>
                          <a onClick={this.handleBulkActionSelect('MakePublic')}>Make Public</a>
                        </li>
                        <li>
                          <a onClick={this.handleBulkActionSelect('MakePrivate')}>Make Private</a>
                        </li>
                        <li role="separator" className="divider" />

                        <li>
                          <a onClick={this.handleBulkActionSelect('Replicate')}>Replicate</a>
                        </li>
                      </ul>
                    </div>

                    <button
                      type="button"
                      className="text-medium font-weight-600"
                      onClick={this.handleAddNewEpisode}>
                      Add track
                    </button>
                  </ActionButtonWrappers>
                </div>
              </FlexiRow>
              <EpisodesHeadRow className="row" alignItems="center">
                <EpisodeColumn className="col-md-7">
                  <EpisodeRowTitle>
                    <CheckboxWrapper width={25}>
                      <Checkbox
                        checked={selectAllEpisodes || this.isAllEpisodesSelected()}
                        onCheck={this.handleEpisodeSelectAll}
                        labelStyle={{
                          fontSize: '1.6rem',
                          fontWeight: 'normal',
                        }}
                        iconStyle={{
                          width: 25,
                          height: 25,
                          fill: '#ff8f53',
                        }}
                      />
                      {selectedEpisodes.length ? (
                        <div className="items-selected">{selectedEpisodes.length} selected</div>
                      ) : null}
                    </CheckboxWrapper>
                    <div className="header-text text-large text-blue-gray">TITLE</div>
                  </EpisodeRowTitle>
                </EpisodeColumn>
                <EpisodeColumn className="col-md-2 text-center text-large">
                  <div className="text-large text-blue-gray">STATUS</div>
                </EpisodeColumn>
                <EpisodeColumn className="col-md-2 text-center text-large">
                  <div className="text-large text-blue-gray">LENGTH</div>
                </EpisodeColumn>
                <EpisodeColumn className="col-md-1 text-center text-large">
                  <div className="text-large text-blue-gray">ANALYTICS</div>
                </EpisodeColumn>
              </EpisodesHeadRow>
            </div>
            {loading && (
              <LoadingWrapper float={true}>
                <Loading text={loadingMsg} align="center" size={50} fontSize={2} height={90} />
              </LoadingWrapper>
            )}
            <ScrollableContent ref={this.scrollContentHandler}>
              {isEmpty(episodes) && !loading && (
                <EmptyEpisodeList>
                  <span className="text-extra-large">No track, create one now!</span>
                </EmptyEpisodeList>
              )}
              {this.renderEpisodeList()}
            </ScrollableContent>
            <EpisodeStatsModal
              isShown={this.state.showStatsModal}
              episode={this.state.currentEpisode}
              onClose={this.handleStatsModal}
              userInfo={this.props.userInfo}
            />
            {this.renderAlertModal()}
            {this.renderBulkReplicateModal()}
          </FloatingFlexiWrapper>
        </RelativeContainer>
      </MuiThemeProvider>
    );
  }
}

const EpisodesLoader = styled.div`
  width: 100%;
  background: #fff;
`;

export default SoundcastEpisodes;
